import CsHeader from './CsHeader.vue'
CsHeader.install = function (Vue) {
  Vue.component(CsHeader.name, CsHeader)
}
export default CsHeader


// WEBPACK FOOTER //
// ./src/components/header/index.js